// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.456.0-TSS-2905-mcastro-FEATURE-Loading-Bar-Exploration.1";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
